var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-cover-navbar bg-shop row"},[_c('div',{staticClass:"p-shop"},[_c('div',{staticClass:"shop-panel col-lg-8 col-md-10 col-sm-12 mx-auto"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }